export const circleIcon = (bg: string, mb = 16) => ({
  width: 48,
  height: 48,
  padding: 12,
  borderRadius: '50%',
  backgroundColor: bg,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: `0 auto ${mb}px`
});

export const squareIcon = (bg: string) => ({
  width: 40,
  height: 40,
  padding: 10,
  borderRadius: 8,
  backgroundColor: bg,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 16
});